import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { PropuestaComponent } from './propuesta/propuesta.component';
import { VerificacionComponent } from './verificacion/verificacion.component';
import { ResultadoComponent } from './resultado/resultado.component';
import { ProntoPagoStateService } from '../../services/pronto-pago-state.service';
import { IframeResizeService } from '../../services/iframe-resize.service';

export type PasoProntoPago = 'propuesta' | 'verificacion' | 'resultado';

/**
 * Contenedor del flujo "Pronto Pago".
 *
 * Este portal enruta sobre un parámetro `:qs` en Base64 y cualquier navegación real
 * reconstruye `HomeComponent`, lo que dentro del `iframe` puede perder el contexto de sesión.
 * Por eso los tres pasos no son rutas, sino estado interno: los hijos emiten eventos y este
 * componente decide qué paso mostrar. La URL nunca cambia.
 */
@Component({
  selector: 'app-pronto-pago',
  standalone: true,
  imports: [
    CommonModule,
    PropuestaComponent,
    VerificacionComponent,
    ResultadoComponent
  ],
  templateUrl: './pronto-pago.component.html'
})
export class ProntoPagoComponent implements OnInit {

  /** `resultado` cuando el usuario ya aceptó la oferta; `propuesta` en el resto de los casos. */
  @Input() pasoInicial: PasoProntoPago = 'propuesta';

  /** El usuario terminó el flujo y quiere volver al portal. */
  @Output() salir = new EventEmitter<void>();

  paso: PasoProntoPago = 'propuesta';

  constructor(
    private readonly estado: ProntoPagoStateService,
    private readonly iframeResizeService: IframeResizeService
  ) { }

  ngOnInit(): void {
    this.paso = this.pasoInicial;
  }

  irA(paso: PasoProntoPago): void {
    this.paso = paso;
    // Cada paso tiene un alto muy distinto; sin esto el usuario queda mirando el medio de la
    // pantalla dentro del iframe.
    this.iframeResizeService.solicitarScrollArriba();
  }

  terminar(): void {
    this.estado.reset();
    this.salir.emit();
  }
}
